import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Top } from './components/top/top';
import { Info } from './components/info/info';
import { Work } from './components/work/work';
import { Products } from './components/products/products';
import { Company } from './components/company/company';
import { Reclute } from './components/reclute/reclute';
import { OnlineShop } from './components/onlineshop/onlineshop';
import './App.css';

const App = () => {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route index element={<Top />} />
          <Route path='news' element={<Info />} />
          <Route path='work' element={<Work />} />
          <Route path='products' element={<Products />} />
          <Route path='company' element={<Company />} />
          <Route path='reclute' element={<Reclute />} />
          <Route path='shop' element={<OnlineShop />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
